import React, { useEffect } from 'react';
import './contact.css'
import Navbar from '../H&F/Navbar';
import Discliamber from './Discliamer'
import Footer from '../H&F/Footer';
export default function CONTACT() {


  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  return (
    <>

    <div><Navbar/></div>
      <section id="contact-page">
        <div className="contact-header">
          <h2>Contact Us</h2>
          <p>We are here to serve you! Reach out to us for all your home appliance repair needs in Madurai.</p>
        </div>

        <div className="contact-info">
          <div className="address">
            <h3>Our Location</h3>
            <p>We are located in the heart of Madurai, easily accessible from all parts of the city. Visit us for reliable and quick home appliance repairs.</p>
            <p><strong>Address:</strong>Sarvodaya 4th Street, New Ellis Nagar, Madurai -625016</p>
            <p><strong>Contact Number:</strong>+918610867933</p>
            <p><strong>Email:</strong>hasmadurai@gmail.com</p>
          </div>
          <div className="map">
            <h3>Find Us on the Map</h3>
            <div id="madurai-map">
            <iframe 
  src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d736.0827729848058!2d78.10292631922651!3d9.916469984618054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1737372481541!5m2!1sen!2sin" 
  width="600" 
  height="450" 
  style={{ border: 0 }} 
  allowFullScreen="" 
  loading="lazy" 
  referrerPolicy="no-referrer-when-downgrade">
</iframe>

            </div>
          </div>
        </div>

        <div className="business-hours">
          <h3>Business Hours</h3>
          <p>We are open every day to assist with your appliance repair needs!</p>
          <ul>
            <li><strong>Monday - Friday:</strong> 9:00 AM - 9:00 PM</li>
            <li><strong>Saturday:</strong> 9:00 AM - 7:00 PM</li>
            <li><strong>Sunday:</strong> Closed</li>
          </ul>
        </div>

        <div className="contact-footer">
          <h3>Get in Touch</h3>
          <p>Have questions? Want to schedule a service or inquire about any repairs? Feel free to contact us via email, phone, or visit us directly.</p>
        </div>
      </section>
<div><Discliamber/></div>

            <div><Footer /></div>
    </>
  );
}
